import { render, staticRenderFns } from "./loginCard.vue?vue&type=template&id=180cbf28&scoped=true&"
import script from "./loginCard.vue?vue&type=script&lang=js&"
export * from "./loginCard.vue?vue&type=script&lang=js&"
import style0 from "./loginCard.vue?vue&type=style&index=0&id=180cbf28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cbf28",
  null
  
)

export default component.exports